/* eslint-disable @typescript-eslint/no-namespace */
import {Window, GetUrlPositionalArgs, GetUrlKeyValueArgs} from 'airship/types'

declare const window: Window

import APPKEY from 'airship/modules/app_key'

const WINDOW_PROPERTY = 'Urls'

/**
 * Generate or "reverse" a URL from a Django URL pattern given optional arguments.
 * Ex: `getUrl('my_cool_url', 4)` | `getUrl('my_cool_url', {id: 4})`
 *
 * A wrapper around django-js-reverse, for further information see https://github.com/ierror/django-js-reverse#django-js-reverse
 * @param name Django URL pattern name to render
 * @param args Arguments to pass to the URL pattern, positional or key/value
 * @throws Error is thrown if `name` is not present in js-urls: Django namespace
 * @throws Error is thrown if URL cannot be rendered with given `args`.
 */
function getUrl(
  name: string,
  ...args: GetUrlPositionalArgs | GetUrlKeyValueArgs
): string {
  if (!name.startsWith('js-urls:')) {
    name = 'js-urls:' + name
  }
  const urls = window[WINDOW_PROPERTY] || {}
  const urlFn = urls[name]

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!urlFn) throw new Error(`No such URL available: ${name}`)

  const url: string | null = urlFn(...args)

  if (!url) throw new Error(`Failed to generate URL for ${name}`)

  return url
}
namespace getUrl {
  export const URLS_PROPERTY = WINDOW_PROPERTY
  export const APP_KEY = APPKEY
}

export = getUrl
